import React from "react";

const TransformIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" className="efmd-edge__chip-icon" aria-hidden="true">
    <path d="M9 8l-4 4 4 4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 8l4 4-4 4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 6l-2 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const ScriptIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" className="efmd-edge__chip-icon" aria-hidden="true">
    <path d="M10 6L6 12l4 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 6l4 6-4 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PipelineIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" className="efmd-edge__chip-icon" aria-hidden="true">
    <circle cx="5" cy="12" r="2" fill="currentColor" />
    <circle cx="12" cy="12" r="2" fill="currentColor" />
    <circle cx="19" cy="12" r="2" fill="currentColor" />
    <path d="M7 12h3M14 12h3" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const getPath = (sx, sy, tx, ty) => {
  const dx = Math.max(3, Math.abs(tx - sx) * 0.35);
  const direction = tx >= sx ? 1 : -1;
  const c1x = sx + direction * dx;
  const c2x = tx - direction * dx;
  return `M ${sx} ${sy} C ${c1x} ${sy}, ${c2x} ${ty}, ${tx} ${ty}`;
};

const MappingOverlay = ({
  edges,
  layout,
  selectedEdgeId,
  onSelectEdge,
  onOpenTransform,
  onDeleteEdge,
  isEdgeInvalid,
  draggingLine,
}) => {
  const orderedEdges = [...edges].sort((a, b) => {
    const aSelected = a.id === selectedEdgeId ? 1 : 0;
    const bSelected = b.id === selectedEdgeId ? 1 : 0;
    return aSelected - bSelected;
  });

  return (
    <div className="efmd-overlay">
      <svg className="efmd-overlay__svg">
        {orderedEdges.map((edge, index) => {
          const points = layout[edge.id];
          if (!points) return null;
          const selected = selectedEdgeId === edge.id;
          const invalid = isEdgeInvalid(edge);
          const cx = (points.sx + points.tx) / 2;
          const cy = (points.sy + points.ty) / 2;
          const stepCount = Array.isArray(edge?.transformSteps) ? edge.transformSteps.length : 0;
          const isConstant = edge?.isConstant === true;
          const legacyCustomScript = String(
            edge?.legacyCustomTransformScript ||
            edge?.raw?.CustomTransformScript ||
            edge?.raw?.customTransformScript ||
            ""
          ).trim();
          const hasPipeline = stepCount > 0;
          const hasLegacyCustomScript = legacyCustomScript.length > 0 && !hasPipeline;
          const state = hasPipeline ? "pipeline" : hasLegacyCustomScript ? "script" : "empty";
          const chipTitle = isConstant
            ? "Constant mapping"
            : state === "script"
              ? "Single custom transform script is set"
              : state === "pipeline"
                ? "Pipeline transform is set"
                : "No transform configured";
          const chipWidth = 2.1 * 16;
          const chipX = isConstant ? points.sx : cx;
          const chipY = isConstant ? points.sy : cy;
          const chipHeight = isConstant ? 1.7 * 16 : 1.55 * 16;
          const chipYOffset = isConstant ? 3 : 0;

          return (
            <g key={`${edge.id}:${index}`}>
              <path
                className={`efmd-edge ${selected ? "is-selected" : ""} ${invalid ? "is-invalid" : ""}`}
                d={getPath(points.sx, points.sy, points.tx, points.ty)}
                onClick={() => onSelectEdge(edge.id)}
                onDoubleClick={() => onOpenTransform(edge.id)}
              />
              <foreignObject
                x={chipX - chipWidth / 2}
                y={chipY - chipHeight / 2 + chipYOffset}
                width={chipWidth}
                height={chipHeight}
              >
                <button
                  type="button"
                  className={`efmd-edge__chip ${selected ? "is-selected" : ""} ${invalid ? "is-invalid" : ""}`}
                  title={chipTitle}
                  aria-label={chipTitle}
                  onClick={() => {
                    onSelectEdge(edge.id);
                    onOpenTransform(edge.id);
                  }}
                >
                  {isConstant ? (
                    <span className="efmd-edge__chip-constant">C</span>
                  ) : state === "script" ? (
                    <ScriptIcon />
                  ) : state === "pipeline" ? (
                    <PipelineIcon />
                  ) : (
                    <TransformIcon />
                  )}
                </button>
              </foreignObject>
            </g>
          );
        })}
        {draggingLine && (
          <path className="efmd-edge is-dragging" d={getPath(draggingLine.sx, draggingLine.sy, draggingLine.tx, draggingLine.ty)} />
        )}
      </svg>
    </div>
  );
};

export default MappingOverlay;
